import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {  useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Copy } from "react-feather";
import Table2 from '../../../core/pagination/datatable2'
import { dateFormatter, getBalanceMessage2, dateFormatter2, getCurrencySymbol } from '../../../plugins/helper';
import { Modal, message } from "antd";

const ViewCustomerOrders = ({ customer,orderList }) => {
  const filteredOrder =  orderList?.filter(item => item?.shippingAddress.email == customer?.email);
  const language = useSelector((state) => state.language || 'en');
  const translation = useSelector((state) => state.translation || {});
  const closeRef2 = useRef(null);
 
  const columns = 
  [
    {
        title: translation[language]?.["order_number"] || "Order Number",
        dataIndex: "_id",
    },
    {
        title: translation[language]?.["chassis_numbers"] || "Chassis Numbers",
        dataIndex: "chassisNumbers",
    },
    {
        title: translation[language]?.["customer"] || "Customer",
        dataIndex: "shippingAddress",
        render: (text) => <span>{text?.name || ""}</span>,
    },
    
    
    {
        title: translation[language]?.["date"] || "Date",
        dataIndex: "createdAt",
        render: (text) => <span>{dateFormatter(text, language)}</span>,
    },
    {
      title: translation[language]?.["departure_date"] || "Departure Date",
      dataIndex: "departureDate",

      render: (text) => <span>{dateFormatter2(text, language)}</span>,
      // sorter: (a, b) => a.email.length - b.email.length,
    },
    {
        title: translation[language]?.["total_amount"] || "Total Amount",
        dataIndex: "grossTotal",
        render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
    },
    {
        title: translation[language]?.["amount_paid"] || "Amount Paid",
        dataIndex: "totalPaid",
        render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
    },
    {
        title: translation[language]?.["recieved_misc"] || "Recieved Misc",
        dataIndex: "tAddiPayment",
        render: (value) => `${getCurrencySymbol()}${(value || 0).toLocaleString()}`
    },

    {
        title: translation[language]?.["balance"] || "Balance",
        render: (_, record) => {
            const grossTotal = record.grossTotal || 0;
            const totalPaid = record.totalPaid || 0;
          
            const balance = grossTotal - totalPaid;
            return `${getCurrencySymbol()}${balance.toLocaleString()}`;
        }
    },
    {
        title: translation[language]?.["paid_percentage"] || "Paid %",
        render: (_, record) => {
            const grossTotal = record.grossTotal || 0;
            const totalPaid = record.totalPaid || 0;
            const percentage = grossTotal > 0 ? (totalPaid / grossTotal) * 100 : 0;
            return `${percentage.toFixed(0)}%`;
        }
    },
          
    {
      title: translation[language]?.["message"] || "Message",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
              <Link
                className="me-2 p-2"
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  console.log("record record",record)

                  const grossTotal = record.grossTotal || 0;
                  const totalPaid = record.totalPaid || 0;
                  const balance = grossTotal - totalPaid;
                  // const chassisNum = record.chassisNumbers || null;
                  // const invoice = record._id
                  const name = `${record.shippingAddress.name || ""}`;
                  const msg = getBalanceMessage2(translation[language]?.["message_company"] || "Pak Nippon Corporation, Japan", name, [record],balance, null,'viewcust');

                  navigator.clipboard.writeText(msg).then(() => {
                    message.success("Message copied to clipboard!");
            
                    Modal.info({
                      title: "Message",
                      content: <pre style={{ whiteSpace: "pre-wrap" }}>{msg}</pre>,
                      okText: "Close",
                      okButtonProps: {
                        style: { backgroundColor: "#BC8F8F", borderColor: "#BC8F8F", color: "#fff" },
                      },
                    });
                  }).catch(() => {
                    message.error("Failed to copy message.");
                  });
                  // navigator.clipboard.writeText(msg).then(() => {
                  //   message.success("Message copied to clipboard!");
                  //   alert(msg);
                  // }).catch(() => {
                  //   message.error("Failed to copy message.");
                  // });
                }}
              >
                <Copy className="feather-copy" />
              </Link>
            
          </div>
        </div>
      ),
      // sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];
   
   useEffect(() => {
    if (customer) {
      console.log("Customer:", customer); 
    }
  }, [customer]);

  useEffect(() => {
    const handleHidden = () => {
   
    };

    const modalElement = document.getElementById("add-units");
    modalElement?.addEventListener("hidden.bs.modal", handleHidden);

    return () => {
      modalElement?.removeEventListener("hidden.bs.modal", handleHidden);
    };
  }, []);


  return (
    <div>
      <div className="modal fade" id="edit-units">
        <div className="modal-dialog modal-xl modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{translation?.[language]?.["view_customer_orders"] ?? "View Customer Orders"} ({customer?.profile?.firstName} {customer?.profile?.lastName})</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef2}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                <div className="card table-list-card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <Table2 columns={columns} dataSource={filteredOrder} key={filteredOrder._id} />
                        </div>
                    </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ViewCustomerOrders.propTypes = {
  customer: PropTypes.object,
  orderList: PropTypes.array
};

export default ViewCustomerOrders;